// DS: i3.8
import React from 'react';
import IconWrap from '../../IconWrap';
const Download = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M11.586 14a.5.5 0 110 1h-7a.5.5 0 110-1h7zm-1.5-13a1 1 0 01.993.883l.007.117v3h1.586a1 1 0 01.79 1.613l-.083.094-4.586 4.586a1 1 0 01-1.32.083l-.094-.083-4.586-4.586a1 1 0 01.59-1.7L3.5 5h1.586V2a1 1 0 01.883-.993L6.086 1h4zm0 1h-4v4H3.5l4.585 4.586L12.67 6h-2.584V2z",
        fillRule: "evenodd"
    })));
};
Download.displayName = 'Download';
export default Download;

//# sourceMappingURL=Download.js.map